export default __webpack_public_path__ + "static/media/190629_190332_Joe 1 JPEG.7c5ac100.jpg";